 


document.addEventListener('DOMContentLoaded', () => {
  const hasCollectionList = document.querySelector('.collection-list');
  const hasProductList = document.querySelector('.product-list');

  if (
    window.innerWidth >= 990 &&
    document.body.classList.contains('template-product') &&
    (hasCollectionList || hasProductList)
  ) {
    window.scrollTo({
      top: 250,
      behavior: 'instant'
    });
  }
});



function setRMHomeWidth() {
  if (window.innerWidth > 989) return;

  const header = document.querySelector('.rm-home__work-header');

  if (!header) return;

  requestAnimationFrame(() => {
    const width = header.getBoundingClientRect().width;

    document.documentElement.style.setProperty(
      '--rm-home-width',
      `${width}px`
    );
  });
}

setRMHomeWidth();

window.addEventListener('resize', setRMHomeWidth);

const rmHeader = document.querySelector('.rm-home__work-header');

if (rmHeader) {
  const resizeObserver = new ResizeObserver(() => {
    setRMHomeWidth();
  });

  resizeObserver.observe(rmHeader);
}

const cartDrawer = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer');

if (cartDrawer) {
  const cartObserver = new MutationObserver(() => {
    setRMHomeWidth();
  });

  cartObserver.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ['class', 'open', 'style', 'aria-hidden']
  });
}






const workButton = document.querySelector('.rm-home__work-count');
const categoryFilter = document.querySelector('.rm-home__category-filter');

function updateWorkOpacity() {
  if (!categoryFilter.hasAttribute('hidden')) {
    workButton.classList.add('is-open');
  } else {
    workButton.classList.remove('is-open');
  }
}

updateWorkOpacity();

const observer = new MutationObserver(updateWorkOpacity);

observer.observe(categoryFilter, {
  attributes: true,
  attributeFilter: ['hidden']
});







